
import { Link } from 'react-router-dom';

export default function MedicalPurchase() {
  const purchaseSites = [
    {
      title: 'アスクル（医療・介護用品）',
      description: '医療機関向けの医療用品・消耗品の総合通販サイト',
      url: '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3755218&pid=892142087',
      category: '医療用品',
      icon: 'ri-hospital-line',
      color: 'bg-blue-50 text-blue-600',
      features: ['医療機器', '消耗品', '衛生用品', '検査用品'],
      isAskul: true
    },
    {
      title: 'モノタロウ（医療・介護）',
      description: '医療・介護施設向けの設備・用品を幅広く取り扱い',
      url: 'https://www.monotaro.com/',
      category: '医療設備',
      icon: 'ri-tools-line',
      color: 'bg-green-50 text-green-600',
      features: ['医療設備', '介護用品', '清掃用品', '安全用品']
    },
    {
      title: 'ミドリ安全（医療用品）',
      description: '医療従事者向けの安全用品・衛生用品専門店',
      url: 'https://www.midori-anzen.co.jp/',
      category: '安全用品',
      icon: 'ri-shield-check-line',
      color: 'bg-purple-50 text-purple-600',
      features: ['防護服', 'マスク', '手袋', '消毒用品']
    },
    {
      title: 'メディカルネット',
      description: '医療機関専用の医療機器・用品オンラインストア',
      url: 'https://www.medical-net.com/',
      category: '医療機器',
      icon: 'ri-stethoscope-line',
      color: 'bg-red-50 text-red-600',
      features: ['診断機器', '治療機器', '検査機器', 'IT機器']
    },
    {
      title: 'ケアネット（介護用品）',
      description: '介護施設・在宅介護向けの用品専門サイト',
      url: 'https://www.carenet.com/',
      category: '介護用品',
      icon: 'ri-wheelchair-line',
      color: 'bg-teal-50 text-teal-600',
      features: ['車椅子', 'ベッド', '入浴用品', 'リハビリ用品']
    }
  ];

  const categories = [
    {
      name: '医薬品',
      description: '処方薬・OTC医薬品・試薬等',
      icon: 'ri-capsule-line',
      items: ['処方薬', 'OTC医薬品', '試薬', '診断薬', 'ワクチン', '輸液']
    },
    {
      name: '医療機器',
      description: '診断・治療・検査機器',
      icon: 'ri-heart-pulse-line',
      items: ['診断機器', '治療機器', '検査機器', 'モニター', '人工呼吸器', 'X線装置']
    },
    {
      name: '医療用品',
      description: '消耗品・衛生用品等',
      icon: 'ri-first-aid-kit-line',
      items: ['注射器', 'カテーテル', 'ガーゼ', '包帯', '手袋', 'マスク']
    },
    {
      name: '介護用品',
      description: '介護・リハビリ関連用品',
      icon: 'ri-wheelchair-line',
      items: ['車椅子', '介護ベッド', '歩行器', '入浴用品', 'リハビリ用品', '福祉用具']
    }
  ];

  const purchaseGuidelines = [
    {
      title: '薬事法の遵守',
      description: '医薬品・医療機器の購入は薬事法に基づいて行う',
      icon: 'ri-shield-check-line',
      points: [
        '許可を受けた業者からの購入',
        '適切な保管・管理の実施',
        '記録の保持と管理',
        '品質管理の徹底'
      ]
    },
    {
      title: '品質保証',
      description: '医療の安全性確保のための品質管理',
      icon: 'ri-award-line',
      points: [
        '製造販売承認の確認',
        'GMP基準の遵守',
        '有効期限の管理',
        'トレーサビリティの確保'
      ]
    },
    {
      title: '適正価格',
      description: '医療経済性を考慮した購入',
      icon: 'ri-money-yen-circle-line',
      points: [
        '複数業者からの見積もり',
        '薬価基準の参照',
        'ジェネリック医薬品の活用',
        'コストパフォーマンスの評価'
      ]
    },
    {
      title: '安全管理',
      description: '医療安全の確保と事故防止',
      icon: 'ri-security-line',
      points: [
        '取り扱い説明書の確認',
        '安全性情報の収集',
        '副作用情報の把握',
        '緊急時対応の準備'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-green-50 to-emerald-50 py-16">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/7fd08aee36800fb7b827ebc42b9202d0.jpg"
            alt="医療・介護用品サイト"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            <span className="text-green-600">医療・介護用品</span>サイト
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            信頼できる医療機器・医療用品・介護用品の購入サイト情報
          </p>
        </div>
      </section>

      {/* Purchase Sites */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">主要購入サイト</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {purchaseSites.map((site, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-6 border border-gray-100">
                <div className={`w-12 h-12 rounded-lg ${site.color} flex items-center justify-center mb-4`}>
                  <i className={`${site.icon} text-xl`}></i>
                </div>
                <div className="mb-3">
                  <span className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded-full">{site.category}</span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{site.title}</h3>
                <p className="text-gray-600 mb-4 text-sm">{site.description}</p>
                <div className="mb-4">
                  <p className="text-sm font-medium text-gray-700 mb-2">取扱商品:</p>
                  <div className="flex flex-wrap gap-1">
                    {site.features.map((feature, featureIndex) => (
                      <span key={featureIndex} className="bg-gray-50 text-gray-600 text-xs px-2 py-1 rounded">
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
                {site.isAskul ? (
                  <a
                    href="//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3755218&pid=892158038"
                    rel="nofollow"
                    target="_blank"
                    className="text-green-600 font-medium hover:text-green-700 cursor-pointer text-sm"
                  >
                    アスクルなら欲しいモノがすぐ見つかる、すぐ届く！ →
                    <img 
                      src="//ad.jp.ap.valuecommerce.com/servlet/gifbanner?sid=3755218&pid=892158038" 
                      height="1" 
                      width="1" 
                      border="0"
                      alt=""
                      className="hidden"
                    />
                  </a>
                ) : (
                  <a
                    href={site.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-green-600 font-medium hover:text-green-700 cursor-pointer text-sm"
                  >
                    サイトを見る →
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">商品カテゴリー</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {categories.map((category, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
                <div className="w-12 h-12 bg-green-100 text-green-600 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${category.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{category.name}</h3>
                <p className="text-gray-600 mb-4 text-sm">{category.description}</p>
                <ul className="space-y-1">
                  {category.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="text-sm text-gray-500 flex items-center">
                      <i className="ri-check-line text-green-600 mr-2"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Askul Banner Section */}
      <section className="py-16 bg-gradient-to-br from-blue-50 to-indigo-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">医療・介護用品のお求めは</h2>
          <p className="text-lg text-gray-600 mb-8">
            豊富な品揃えと迅速な配送で、医療現場をサポートします
          </p>
          <div className="flex justify-center">
            <script language="javascript" src="//ad.jp.ap.valuecommerce.com/servlet/jsbanner?sid=3755218&pid=892158035"></script>
            <noscript>
              <a href="//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3755218&pid=892158035" rel="nofollow">
                <img src="//ad.jp.ap.valuecommerce.com/servlet/gifbanner?sid=3755218&pid=892158035" border="0" alt="アスクルバナー" />
              </a>
            </noscript>
          </div>
        </div>
      </section>

      {/* Purchase Guidelines */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">購入時の注意事項</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {purchaseGuidelines.map((guideline, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
                <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${guideline.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{guideline.title}</h3>
                <p className="text-gray-600 mb-4 text-sm">{guideline.description}</p>
                <ul className="space-y-2">
                  {guideline.points.map((point, pointIndex) => (
                    <li key={pointIndex} className="text-sm text-gray-600 flex items-start">
                      <i className="ri-arrow-right-s-line text-blue-600 mr-1 mt-0.5"></i>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Important Notice */}
      <section className="py-16 bg-yellow-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-xl shadow-lg p-8 border-l-4 border-yellow-400">
            <div className="flex items-start">
              <div className="w-8 h-8 bg-yellow-100 text-yellow-600 rounded-full flex items-center justify-center mr-4 mt-1">
                <i className="ri-alert-line"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">重要なお知らせ</h3>
                <div className="space-y-3 text-gray-700">
                  <p>
                    <strong>医薬品の購入について：</strong>
                    医療用医薬品は医師の処方箋に基づいて薬局・薬店で購入してください。
                    インターネットでの医療用医薬品の個人輸入は、安全性や有効性が保証されず、健康被害のリスクがあります。
                  </p>
                  <p>
                    <strong>医療機器の購入について：</strong>
                    医療機器は適切な許可を受けた販売業者から購入し、使用前に必ず取扱説明書を確認してください。
                    不適切な使用は医療事故につながる可能性があります。
                  </p>
                  <p>
                    <strong>法的規制について：</strong>
                    医薬品・医療機器の販売には薬機法（医薬品、医療機器等の品質、有効性及び安全性の確保等に関する法律）による規制があります。
                    購入前に必ず法的要件を確認してください。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">購入サイト</h3>
              <ul className="space-y-2 text-gray-400">
                <li><a href="https://www.askul.co.jp/m/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">アスクル医療用品</a></li>
                <li><a href="https://www.monotaro.com/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">モノタロウ</a></li>
                <li><a href="https://www.midori-anzen.co.jp/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">ミドリ安全</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/pharmacist-resources" className="hover:text-white cursor-pointer">専門リソース</Link></li>
                <li><Link to="/package-insert-search" className="hover:text-white cursor-pointer">添付文書検索</Link></li>
                <li><Link to="/drug-price-search" className="hover:text-white cursor-pointer">薬価サーチ</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/information" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/guidelines" className="hover:text-white cursor-pointer">疾患ガイドライン</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
